var app = angular.module("leonardo");

var OnDemandInstructionsController = function($scope, ngDialog, $state, OnDemandInstructionService, AccountUserService,
                                              FilterService, AuthDataService, $controller, PermissionService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;

  $scope.showCloneAdminDialog = function (instruction) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        onlyClientInstance: true,
        type: 'on demand instruction',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        instruction.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
          $scope.loadPage($scope.page);
        });
      }
    }, function () {
      return;
    });
  };

  $scope.showOnDemandDeleteDialog = function(item) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: item,
        type: 'instruction'
      }
    }).then(function() {
      OnDemandInstructionService.updateCollection(item, true);
    }, function () {
      return;
    });
  };

  $scope.goToForm = function(item) {
    $state.go('on-demand-instructions.instruction-edit', {pk: item.id});
  };

  $scope.getEntitiesPromise = function(options) {
    options['account'] = FilterService.getFilter('account_reports');
    options['client_instance'] = FilterService.getFilter('client_instances', true);
    options['search'] = FilterService.getFilter('search');
    options['category'] = FilterService.getFilter('category');
    options['subcategories'] = FilterService.getFilter('subcategories');
    if (AuthDataService.isNotStaff() && !options['account']) {
      var account = null;
      if(AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.account){
        account = AccountUserService.currentAccountUser.account.id || AccountUserService.currentAccountUser.account
      }
      if (isNull(account)) {
        account = FilterService.accounts.length > 0 ? FilterService.accounts[0].id : null;
      }
      options['account'] = account;
    }
    return OnDemandInstructionService.getlist(options);
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.instruction', {pk: item.id});
  };

  $scope.$on('on-demand-instruction:updated', function(){
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage(1);

};

app.controller('OnDemandInstructionsController', ['$scope', 'ngDialog', '$state', 'OnDemandInstructionService',
  'AccountUserService', 'FilterService', 'AuthDataService', '$controller', 'PermissionService', OnDemandInstructionsController]);
